// extracted by mini-css-extract-plugin
export default {"StakCard":"StakingCard_StakCard__lfu4g","texts":"StakingCard_texts__nidd4"};